import { TripDataReportModel } from './tripdatareport.model';
import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestOptionsArgs, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { JQueryHelperService } from './../../shared/models/jquery-helper.service';

@Injectable()
export class TripDataReportService {
  JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }
   public GetTripData(input: TripDataReportModel): Observable<IAPIResponse> {
    let body = input;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_GET_TRIP_DATA_LIST, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public ExportTripDataReportPDF(input: TripDataReportModel): any {
    let queryString = "InstanceHashId=" + input.instanceHashId + "&CompanyHashId=" + input.companyHashId + "&SharedVehicleGroupHashId=" + input.sharedVehicleGroupHashId + "&DriverHashId=" + input.driverHashId + "&VehicleHashId=" + input.vehicleHashId +
      "&StartDateTime=" + input.startDateTime + "&EndDateTime=" + input.endDateTime + "&isDriverSearch=" + input.isDriverSearch + "&OrganizationHashId=" + input.organizationHashId;
    let getTripDataUrl = WeGoConfig.API_EXPORT_TRIP_DATA_REPORT_PDF + "?" + queryString;
    let headers = this.authService.GetHeader('application/pdf');
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(getTripDataUrl, options);
  }
  public ExportTripDataReportCsv(input: TripDataReportModel): any {
    let queryString = "InstanceHashId=" + input.instanceHashId + "&CompanyHashId=" + input.companyHashId + "&SharedVehicleGroupHashId=" + input.sharedVehicleGroupHashId + "&DriverHashId=" + input.driverHashId + "&VehicleHashId=" + input.vehicleHashId +
      "&StartDateTime=" + input.startDateTime + "&EndDateTime=" + input.endDateTime + "&isDriverSearch=" + input.isDriverSearch + "&OrganizationHashId=" + input.organizationHashId;
    let getTripDataUrl = WeGoConfig.API_EXPORT_TRIP_DATA_REPORT_CSV + "?" + queryString;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(getTripDataUrl, options);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/tripdatareport/models/tripdatareport.service.ts